<template>
  <div class="padding-xl">
    <div class="shadow-warp">
      <div class="padding10 solid-bottom text-red text-lg"><i class="cuIcon-titles"></i> 一、如何申请开票</div>
      <div class="padding10">
        <div class="flex justify-between align-center">
          <div class="flex justify-start align-center">
            <div>
              1.&nbsp;&nbsp;通过短信、邮箱查收发票（或进入“订单查询”界面点击“已开票”下载发票）。<br>
              2.&nbsp;&nbsp;通过对公转账成功后，需登录国家保密科技测评中心官网征订系统、手机端微信小程序或《保密科学技术》公众号上传汇款凭证。五个工作日内，通过短信、邮箱查收发票（或进入“订单查询”界面点击“已开票”下载发票）。</div>
          </div>
        </div>
      </div>
    </div>
    <div class="padding10"></div>
    <div class="shadow-warp">
      <div class="padding10 solid-bottom flex justify-between align-center">
        <div class="text-red text-lg"><i class="cuIcon-titles"></i> 二、如何申请提前开票</div>
      </div>
      <div class="padding10">
        <div class="flex justify-between align-center">
          <div class="flex justify-start align-center">
            <div>订阅10份以上（含10份）订户，需登录国家保密科技测评中心官网，进入“《保密科学技术》在线征订系统”登录，按步骤选择提前开票，10份以下不支持提前开票。</div>
          </div>
        </div>
      </div>
    </div>

    <div class="padding10"></div>
    <div class="shadow-warp">
      <div class="padding10 solid-bottom flex justify-between align-center">
        <div class="text-red text-lg"><i class="cuIcon-titles"></i> 三、如何申请发票红冲</div>
      </div>
      <div class="padding10">
        <div class="flex justify-between align-center">
          <div class="flex justify-start align-center">
            <div>请联系电话（010）55622660由工作人员进行线上发票红冲。</div>
          </div>
        </div>
      </div>
    </div>

    <div class="padding10"></div>
    <div class="shadow-warp">
      <div class="padding10 solid-bottom flex justify-between align-center">
        <div class="text-red text-lg"><i class="cuIcon-titles"></i> 四、如何申请退款</div>
      </div>
      <div class="padding10">
        <div class="flex justify-between align-center">
          <div class="flex justify-start align-center">
            <div>
              1.&nbsp;&nbsp;请联系电话（010）55622660由工作人员进行线上退款。<br>
              2.&nbsp;&nbsp;对公转账订户，请提供退款说明及汇款凭证，发送至邮箱bmkxjs@126.com。退款说明需加盖公章、备注清楚退款原因、退款信息（账号、账户、开户行、退款金额）、联系人及联系电话。退款后续事宜请于5个工作日后联系（010）55622660。</div>
          </div>
        </div>
      </div>
    </div>

    <div class="padding-xl"></div>
  </div>
</template>

<script>
import bs from '@/services/data/bs'

export default {
  name: 'personal',
  data () {
    return {
      modifyPhoneState: false,
      phone: '',
      countdown: 60,
      codeText: '获取验证码',
      loginObject: {
        phone: '',
        captcha: ''
      },
      areaType: 'text',
      selected: {
        province: '',
        city: '',
        area: '',
        town: ''
      },
      addressSelected: {
        province: '',
        city: '',
        area: '',
        town: ''
      },
      user: {},
      address: {
        addressOrg: '',
        addressPhone: '',
        addressArea: '',
        addressStreet: '',
        addressZip: '',
        addressPerson: ''
      },
      invoice: {
        invoiceOrg: '',
        invoiceTaxNum: '',
        invoiceBankAccount: '',
        invoiceBank: '',
        invoiceOrgAddress: '',
        invoicePhone: '',
        invoiceMail: '',
        invoiceReceivePhone: ''
      },
      changeAddress: false,
      changeInvoice: false
    }
  },
  created () {
    this.user = JSON.parse(sessionStorage.getItem('user'))
  },
  watch: {
    user (val, oldVal) {
      if (val) {
        if (val.area) {
          const areas = val.area.split(',', -1)
          this.selected.province = areas[0]
          this.selected.city = areas[1]
          this.selected.area = areas[2]
        }
        this.address.addressOrg = this.user.addressOrg
        this.address.addressPhone = this.user.addressPhone
        this.address.addressStreet = this.user.addressStreet
        this.address.addressZip = this.user.addressZip
        this.address.addressPerson = this.user.addressPerson
        if (val.addressArea) {
          const areas = val.addressArea.split(',', -1)
          this.addressSelected.province = areas[0]
          this.addressSelected.city = areas[1]
          this.addressSelected.area = areas[2]
        }
        this.invoice.invoiceOrg = this.user.invoiceOrg
        this.invoice.invoiceTaxNum = this.user.invoiceTaxNum
        this.invoice.invoiceBankAccount = this.user.invoiceBankAccount
        this.invoice.invoiceBank = this.user.invoiceBank
        this.invoice.invoiceOrgAddress = this.user.invoiceOrgAddress
        this.invoice.invoicePhone = this.user.invoicePhone
        this.invoice.invoiceMail = this.user.invoiceMail
        this.invoice.invoiceReceivePhone = this.user.invoiceReceivePhone
      }
    }
  },
  methods: {
    saveAddress () {
      if (this.changeAddress) {
        this.address.addressArea = this.addressSelected.province + ',' + this.addressSelected.city + ',' + this.addressSelected.area
        bs.user.changeAddress(this.address, (res) => {
          if (res.code === 200) {
            this.$message({
              message: '默认收件地址修改成功',
              type: 'success'
            })
            sessionStorage.setItem('user', JSON.stringify(res.data))
            this.user = res.data
            this.changeAddress = false
          } else {
            this.$message.error('默认收件地址修改失败')
          }
        })
      } else {
        this.changeAddress = true
      }
    },
    saveInvoice () {
      if (this.changeInvoice) {
        bs.user.changeInvoice(this.invoice, (res) => {
          if (res.code === 200) {
            this.$message({
              message: '默认发票信息修改成功',
              type: 'success'
            })
            sessionStorage.setItem('user', JSON.stringify(res.data))
            this.user = res.data
            this.changeInvoice = false
          } else {
            this.$message.error('默认发票信息修改失败')
          }
        })
      } else {
        this.changeInvoice = true
      }
    },
    cancelArea () {
      this.areaType = 'text'
    },
    modifyArea () {
      if (this.areaType === 'text') {
        this.areaType = 'select'
      } else {
        if (this.selected.area !== '' && this.selected.area !== 'null') {
          bs.user.changeArea(this.selected.province + ',' + this.selected.city + ',' + this.selected.area, (res) => {
            if (res.code === 200) {
              this.$message({
                message: '行政区划修改成功',
                type: 'success'
              })
              sessionStorage.setItem('user', JSON.stringify(res.data))
              this.user = res.data
            } else {
              this.$message.error('行政区划修改失败')
            }
          })
        } else {
          this.$message.error('请选择到区县')
          return false
        }
        this.areaType = 'text'
      }
    },
    cancelPhone () {
      this.modifyPhoneState = false
    },
    modifyPhone () {
      if (this.modifyPhoneState) {
        this.changePhone()
        this.modifyPhoneState = false
      } else {
        this.modifyPhoneState = true
      }
    },
    canPost () {
      return this.modifyPhoneState === false || (this.loginObject.phone.length === 11 && this.loginObject.captcha.length === 6)
    },
    canSend () {
      return this.loginObject.phone.length === 11 && this.countdown === 60
    },
    sendCaptcha () {
      if (this.canSend()) {
        bs.user.code(this.user.phone, this.loginObject.phone, (res) => {
          if (res.code === 200) {
            this.$message({
              message: '验证码发送成功',
              type: 'success'
            })
            this.countdown = 59
            this.setCountDown()
          } else if (res.code === 301) {
            this.$message.error('手机号码不正确')
          } else {
            this.$message.error('验证码发送失败')
          }
        })
      }
    },
    changePhone () {
      if (this.canPost()) {
        bs.user.changePhone(this.loginObject.phone, this.loginObject.captcha, (res) => {
          if (res.code === 200) {
            this.$message({
              message: '电话号码修改成功',
              type: 'success'
            })
            sessionStorage.setItem('user', JSON.stringify(res.data))
            this.user = res.data
            if (this.user.phone) {
              this.$emit('phoneChanged', this.user.phone)
            }
          } else {
            this.$message.error('电话号码修改失败')
          }
        })
      }
    },
    setCountDown: function () {
      setTimeout(() => {
        this.codeText = this.countdown + '秒后重试'
        this.countdown--
        if (this.countdown === 0) {
          this.codeText = '获取验证码'
          this.countdown = 60
        } else {
          this.setCountDown()
        }
      }, 1000)
    }
  }
}
</script>

<style scoped>
.info-label {
  width: 80px;
  padding: 2px 0;
  text-align: right;
}

.view-label {
  min-width: 200px;
}

</style>
